import CloseIcon from '@mui/icons-material/Close'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import type { Change } from '../../shared/catalogue-diff'
import type { BoCatalog } from '../../shared/types'
import type { measureBounds as MeasureBounds } from './measureBounds'
import type { ObjectUrlMaker } from './objectUrlLayers'
import PreviewStudio from './PreviewStudio'
import type { TryOn } from './PreviewStudio'

const TITLE_ID = 'avatar-preview-title'

export interface AvatarPreviewDialogProps {
  open: boolean
  onClose: () => void
  catalogue: BoCatalog
  initialSectionId?: string
  tryOn?: TryOn
  changes?: Change[]
  onAddOption?: (sectionId: string) => void
  urls?: ObjectUrlMaker
  measure?: typeof MeasureBounds
}

export default function AvatarPreviewDialog({
  open,
  onClose,
  catalogue,
  initialSectionId,
  tryOn,
  changes,
  onAddOption,
  urls,
  measure,
}: AvatarPreviewDialogProps) {
  const { formatMessage } = useIntl()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth={true}
      aria-labelledby={TITLE_ID}
    >
      <DialogTitle component="div">
        <Stack direction="row" alignItems="flex-start" justifyContent="space-between">
          <Stack>
            <Typography variant="h6" component="h2" id={TITLE_ID}>
              {formatMessage({ id: 'avatarStudio.preview.title' })}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {formatMessage({ id: 'avatarStudio.preview.subtitle' })}
            </Typography>
          </Stack>
          <IconButton
            onClick={onClose}
            aria-label={formatMessage({ id: 'avatarStudio.common.close' })}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        {open && (
          <PreviewStudio
            catalogue={catalogue}
            initialSectionId={initialSectionId}
            tryOn={tryOn}
            changes={changes}
            onAddOption={onAddOption}
            urls={urls}
            measure={measure}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
